import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const qrCodesActions = createActionGroup({
    source: 'Qr Codes',
    events: {
        'Load Qr Code': props<{ url: string }>(),
        'Load Qr Code Success': props<{ url: string; svg: string }>(),
        'Load Qr Code Error': props<{ url: string; code: number }>(),
        // Aborts in-flight and queued loads (e.g. when the requesting popup closes); the cache is kept.
        'Cancel Loading': emptyProps(),
    },
});
